import { createFluentVue } from 'fluent-vue'

import deBundle from './bundles/de.ts'

const bundles = {
	de: deBundle,
}

export const fluent = createFluentVue({
	bundles: [],
})

export function setLocalization(locale: keyof typeof bundles) {
	document.documentElement.lang = locale
	fluent.bundles = [bundles[locale]]
}
